import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {DashboardRessourcesNumeriquesComponent} from "./dashboard-ressources-numeriques/dashboard-ressources-numeriques.component";

const routes = [
  {
    path: '', component: DashboardRessourcesNumeriquesComponent
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
  ],
})
export class RessourcesNumeriquesModule { }
